/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-use-before-define */
/* eslint-disable simple-import-sort/imports */
import { Button, Dialog, DialogContent, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import React, { useState, useEffect } from 'react';
import starReviewIcon from '../../Asset/svg/star_review.svg';
import starReviewFilledIcon from '../../Asset/svg/star_review_filled.svg';

const useStyles = makeStyles(theme => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 8,
      width: 536,
      maxWidth: 'none',
      margin: 0,
      [theme.breakpoints.down('sm')]: {
        width: 'calc(100vw - 32px)',
        maxWidth: 'calc(100vw - 32px)',
        margin: '16px',
      },
    },
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
  content: {
    padding: '32px !important',
    backgroundColor: '#FFFFFF',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    '&:first-child': {
      paddingTop: '32px !important',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '20px !important',
      '&:first-child': {
        paddingTop: '20px !important',
      },
    },
  },
  closeButton: {
    position: 'absolute',
    right: 16,
    top: 16,
    color: '#23296F',
    zIndex: 1,
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    width: 24,
    height: 24,
    padding: 0,
    '&:hover': {
      opacity: 0.7,
    },
    [theme.breakpoints.down('sm')]: {
      right: 8,
      top: 8,
    },
  },
  title: {
    fontSize: 20,
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 600,
    color: '#0E1247',
    textAlign: 'center',
    marginBottom: 22,
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
    },
  },
  starsContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: 16,
    marginBottom: 22,
    [theme.breakpoints.down('sm')]: {
      gap: 12,
    },
  },
  star: {
    width: 33,
    height: 31,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    background: 'none',
    border: 'none',
    padding: 0,
    '&:hover': {
      transform: 'scale(1.1)',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  commentSection: {
    marginBottom: 22,
  },
  commentLabel: {
    fontSize: 14,
    fontFamily: 'Poppins, sans-serif',
    color: '#0E1247',
    marginBottom: 8,
  },
  textField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      border: '1px solid #CDCEDA',
      borderRadius: 4,
      fontSize: 14,
      fontFamily: 'Poppins, sans-serif',
      backgroundColor: '#FFFFFF',
      height: 160,
      padding: '12px',
      overflow: 'auto',
      alignItems: 'flex-start',
      '&:hover': {
        border: '1px solid #CDCEDA',
      },
      '&.Mui-focused': {
        border: '1px solid #CDCEDA',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiOutlinedInput-input': {
      fontSize: 14,
      fontFamily: 'Poppins, sans-serif',
      padding: '0 !important',
      color: '#0E1247',
    },
    '& .MuiInputBase-input::placeholder': {
      fontSize: 14,
      fontFamily: 'Poppins, sans-serif',
      opacity: 1,
      color: '#9799B1',
    },
  },
  submitButton: {
    backgroundColor: '#000A8C',
    color: '#FFFFFF',
    borderRadius: 4,
    padding: '14px 24px',
    fontSize: 14,
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 600,
    textTransform: 'none',
    width: '100%',
    '&:hover': {
      backgroundColor: '#000A8C',
      opacity: 0.9,
    },
    '&:disabled': {
      backgroundColor: '#CDCEDA',
      color: '#9799B1',
    },
  },
}));

interface FeedbackModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (rating: number, comment: string) => void;
  title?: string;
  isSubmitting?: boolean;
  error?: string;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  open,
  onClose,
  onSubmit,
  title = "Qu'avez vous pensé de ce test ?",
  isSubmitting = false,
  error,
}) => {
  const classes = useStyles();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');

  // Reset state when modal closes
  useEffect(() => {
    if (!open) {
      setRating(0);
      setComment('');
    }
  }, [open]);

  const handleStarClick = (starIndex: number) => {
    setRating(starIndex);
  };

  const handleCommentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setComment(event.target.value);
  };

  const handleSubmit = () => {
    if (rating === 0) return;
    const finalComment = comment.trim() || 'Aucun commentaire';
    onSubmit(rating, finalComment);
  };

  const renderStars = () => {
    return Array.from({ length: 5 }, (_, index) => {
      const starNumber = index + 1;
      const isFilled = starNumber <= rating;

      return (
        <button
          key={starNumber}
          type="button"
          className={classes.star}
          onClick={() => handleStarClick(starNumber)}
          aria-label={`${starNumber} étoile${starNumber > 1 ? 's' : ''}`}>
          <img
            src={isFilled ? starReviewFilledIcon : starReviewIcon}
            alt=""
            style={{
              width: 33,
              height: 31,
            }}
          />
        </button>
      );
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.dialog}
      disableScrollLock={true}
      BackdropProps={{
        className: classes.backdrop,
      }}>
      <DialogContent className={classes.content}>
        <CloseIcon className={classes.closeButton} onClick={onClose} />

        <Typography className={classes.title}>{title}</Typography>

        <div className={classes.starsContainer}>{renderStars()}</div>

        <div className={classes.commentSection}>
          <Typography className={classes.commentLabel}>Ajouter un commentaire</Typography>
          <TextField
            className={classes.textField}
            placeholder="Votre commentaire"
            multiline={true}
            variant="outlined"
            value={comment}
            onChange={handleCommentChange}
          />
        </div>

        {error && (
          <Typography
            style={{
              color: '#E74242',
              fontSize: 14,
              fontFamily: 'Poppins, sans-serif',
              textAlign: 'center',
            }}>
            {error}
          </Typography>
        )}

        <Button
          className={classes.submitButton}
          onClick={handleSubmit}
          disabled={rating === 0 || isSubmitting}>
          {isSubmitting ? 'Envoi en cours...' : 'Envoyer mon avis'}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default FeedbackModal;
